import React from 'react'
import Layout from '../Layout'
import CartComponent from '../../../utils/CommonFunctionality/Cart'
import './Cart.css'

const Cart = (props) => {
    return (
        <Layout props={props}>
            <div className="cartOuterWrapper">
                <CartComponent props={props} currency="cad" />
            </div>
        </Layout>
    )
}

export default Cart
